import { Injectable } from '@angular/core';
import { ScreenOrientation, ScreenOrientationResult } from '@capacitor/screen-orientation';
import { from, Subject } from 'rxjs';
import { OrientationLockOptions } from '@capacitor/screen-orientation/dist/esm/definitions';

@Injectable({
    providedIn: 'root',
})
export class ScreenOrientationService {
    public currentScreenOrientationType: ScreenOrientationResult | null = null;
    public screenOrientationChanges$ = new Subject<ScreenOrientationResult>();
    constructor() {}

    public initListener() {
        ScreenOrientation.orientation().then(v => {
            this.currentScreenOrientationType = v;
        });
        ScreenOrientation.addListener('screenOrientationChange', orientation => {
            this.screenOrientationChanges$.next(orientation);
        }).then();
    }

    public destroyListener() {
        ScreenOrientation.removeAllListeners().then();
    }
    public lock(orientation: OrientationLockOptions) {
        return from(ScreenOrientation.lock(orientation));
    }
}
